// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CapsuleButton, CircleButton } = require('client-v2/common/components/buttons')
const InputText = require('client-v2/common/components/input-text')
const Modal = require('client-v2/common/components/modal')
const Icon = require('client-v2/common/containers/icons/component')
const { useTextMeTheAppCallback } = require('client-v2/common/hooks/sms-app')
const tag = require('client-v2/common/utils/hyperscript')


const bem = BemEntity('IntoLandingSMSModal')

function IntoLandingSMSModal(props) {
  const { onDismiss } = props
  return (
    tag(Modal, {
      className: classNames(
        props.className,
        bem.block()
      ),
      onDismiss
    },
      tag(CircleButton, {
        className: bem.element('close-button'),
        onClick: props.onDismiss
      },
        tag(Icon, { id: 'x' })
      ),
      tag('div', {
        className: bem.element('heading')
      },
        props.heading
      ),
      tag('div', {
        className: bem.element('subheading')
      },
        props.subheading
      ),
      tag(SMSModalActions, props)
    )
  )
}

module.exports = IntoLandingSMSModal

function SMSModalActions(props) {
  if (props.isSubmitFailed || props.isSubmitSuccessful) {
    return tag(CapsuleButton, {
      className: bem.element('done-button'),
      onClick: props.onDismiss
    },
      'Done'
    )
  }
  return (
    tag(SMSModalContentForm, props)
  )
}

function SMSModalContentForm(props) {
  // Hooks
  const { onSubmitError, onSubmitSuccess } = props
  const [ phoneNumber, setPhoneNumber ] = React.useState('')
  const onPhoneNumberChange = React.useCallback(
    event => {
      setPhoneNumber(event.target.value)
    },
    [ setPhoneNumber ]
  )
  const textMeTheApp = useTextMeTheAppCallback()
  const onSubmit = React.useCallback(
    event => {
      event.preventDefault()
      textMeTheApp(phoneNumber, onSubmitError, onSubmitSuccess)
      setPhoneNumber('')
    },
    [ onSubmitError, onSubmitSuccess, textMeTheApp, phoneNumber, setPhoneNumber ]
  )
  // Render
  return (
    tag('form', {
      className: bem.element('form'),
      onSubmit
    },
      tag(InputText, {
        className: bem.element('input'),
        inputMode: 'tel',
        placeholder: 'Phone number',
        value: phoneNumber,
        onChange: onPhoneNumberChange
      }),
      tag(CapsuleButton, {
        className: bem.element('submit-button'),
        disabled: !phoneNumber,
        type: 'submit',
        onClick: onSubmit
      },
        'Become a tester'
      )
    )
  )
}
